import { API_BASE } from "../AppConfig";
import * as JOBSTATE_VALIDATION from "./jobState_Validation"; // bad - has paper
import { GetRandomInt, deepCopy, fetchTimeout, toNumber } from "../components/Common";
import { LoadSVGFromData, UpdateAllSVGMaterials } from "../components_designer/layout/PaperFunctions";
import Drawings from "../components_designer/main_drawer/Drawings";
import { GetBracketDataForOpal } from "../components_designer/main_drawer/BracketDesigner";
import {
    BEAMS_AND_POSTS_TOOL,
    DRAWER_TOOLSET_EXPANDED,
    DRAW_FULL_LAYOUT,
    SELECT_POINT,
    SET_TOOLSET_AREA,
    SHAPE_TOOL,
    SHOW_DESIGNER_MESSAGE,
    SHOW_LOADING_BAR,
    THREED_MODE,
    THREED_MINI_MODE,
    TOGGLE_DESIGNER,
    UPDATE_2D_DESIGNER_SVGS,
    UPDATE_3D_MODEL,
    checkInternetConnection,
    updateAPP,
    updateDesigner,
    GENERATING_DOCUMENT,
    GENERATING_DOCUMENT_STATUS,
    getImageBlob,
    blobToBase64,
    DOCUMENT_TO_SHOW,
    showDialogData,
} from "./appState";
import { NEW_JOB, updateDocument, updateQuoteParameters } from "./jobState";
import { GetShapeUpdateString } from "../components_designer/layout/PaperFunctionHelper";
import { jobStateErrorPopups } from "./jobStateWarningPopups";

const { convertJobStateToIni } = require("../components/Common_Conversions");

export const setToolSetArea =
    (area, toolset = null) =>
    async (dispatch, getState) => {
        const last_toolset = getState().app.designer.designer3D[DRAWER_TOOLSET_EXPANDED];
        let threeDMode = getState().app.designer[THREED_MODE];
        let threeDMiniMode = getState().app.designer[THREED_MINI_MODE];

        dispatch({
            type: SET_TOOLSET_AREA,
            area: area,
            toolset: toolset ? toolset : last_toolset,
        });

        let triggeredUpdate = false;

        if (
            toolset !== null &&
            (toolset === BEAMS_AND_POSTS_TOOL || toolset === SHAPE_TOOL || last_toolset === SHAPE_TOOL) &&
            (!threeDMode || (threeDMode && threeDMiniMode))
        ) {
            triggeredUpdate = true;
            return dispatch(updateLayout2D());
        }

        if (toolset !== null && (last_toolset !== toolset || toolset === BEAMS_AND_POSTS_TOOL)) {
            window.app = { ...getState().app };
            UpdateAllSVGMaterials();

            if (toolset === BEAMS_AND_POSTS_TOOL && threeDMode) {
                triggeredUpdate = true;
                return dispatch(updateLayout2D());
            }
        }

        if (!triggeredUpdate) {
            return Promise.resolve(true);
        }
    };

export const setToolSetAreaOnly = (area, toolset) => (dispatch) => {
    dispatch({
        type: SET_TOOLSET_AREA,
        area: area,
        toolset: toolset,
    });
};

export const updateLayout2D =
    (mode = null, area_index = null, drawing_mode = null, force = false, job_data = null) =>
    (dispatch, getState) => {
        if (window.debug && window.location.href.includes("no_eng") && !force) {
            dispatch({
                type: TOGGLE_DESIGNER,
                parameter: SHOW_LOADING_BAR,
                value: false,
            });
            return;
        }

        window.loading3d = false;

        if (window.loading2d) {
            window.loading2d = false;
            return;
        }

        checkInternetConnection(dispatch);
        if (document.hidden) return;

        let online = getState().app.online;

        if (area_index === null) area_index = getState().app?.designer?.designer2D?.AREA_INDEX;
        if (!online)
            return new Promise((resolve) => {
                return resolve(false);
            });

        let user_id = getState().app.user.id;
        if (!job_data) job_data = getState().job;
        if (!job_data) {
            dispatch({
                type: TOGGLE_DESIGNER,
                parameter: SHOW_LOADING_BAR,
                value: false,
            });
            return new Promise((resolve) => {
                return resolve(false);
            });
        }

        if (!job_data.AreaSpecifications.length === 0) {
            dispatch({
                type: TOGGLE_DESIGNER,
                parameter: SHOW_LOADING_BAR,
                value: false,
            });
            return new Promise((resolve) => {
                return resolve(false);
            });
        }

        setTimeout(() => {
            if (window.loading2d) {
                dispatch({
                    type: TOGGLE_DESIGNER,
                    parameter: SHOW_LOADING_BAR,
                    value: true,
                });
            }
        }, 1500);

        const toolopen = getState().app.designer.designer3D[DRAWER_TOOLSET_EXPANDED];
        const select_point = getState().app.designer.designer2D[SELECT_POINT];
        const draw_full_layout = getState().app.designer.designer2D[DRAW_FULL_LAYOUT];
        const threeDMode = getState().app.designer[THREED_MODE];
        const threeDMiniMode = getState().app.designer[THREED_MINI_MODE];

        let id = getState().job.id;

        let api_url = API_BASE() + "svg/" + id + "/selection";
        if (job_data.DesignParameters.DeckMode === 1 || job_data.DesignParameters.LouvreMode === 1) {
            api_url = API_BASE() + "svg/" + id + "/selection";
        } else if (toolopen === SHAPE_TOOL && job_data.DesignParameters.DeckMode !== 1 && !draw_full_layout) {
            api_url = API_BASE() + "svg/" + id + "/";
        } else if (toolopen === BEAMS_AND_POSTS_TOOL && area_index === -1 && !select_point) {
            api_url = API_BASE() + "svg/" + id + "/engineering";
            if (!job_data?.SiteParameters?.WindData?.WindZoneAS1170) {
                api_url = API_BASE() + "svg/" + id + "/selection";
                dispatch({
                    type: SHOW_DESIGNER_MESSAGE,
                    message: {
                        message:
                            "Wind data loading in background. Proceed with job design. Engineering will load after Wind.",
                        type: "warning",
                    },
                });
            }
        }

        if (drawing_mode && drawing_mode === "engineering") {
            window.getting_engineering = true;
            api_url = API_BASE() + "svg/" + id + "/engineering";
            if (!job_data?.SiteParameters?.WindData?.WindZoneAS1170) {
                api_url = API_BASE() + "svg/" + id + "/selection";
                dispatch({
                    type: SHOW_DESIGNER_MESSAGE,
                    message:
                        "Error: Wind data must be defined to engineer this design. Please Wait until Wind has loaded.",
                });
            }
        }

        let job_ini = convertJobStateToIni(job_data, getState().app, "", getState().config);

        window.loading2d = true;
        if (window.loading2d_controller) {
            window.loading2d_controller.abort();
            if (window.loading2d_id) {
                window.fetchTimeoutCompleted[window.loading2d_id] = true;
            }
        }
        let request_id = Date.now();
        window.loading2d_id = request_id;
        if (window.AbortController) {
            window.loading2d_controller = new AbortController();
        }

        if (mode) api_url = API_BASE() + "svg/" + id + "/" + mode;

        let timeout = 30000;
        if (job_data?.DesignParameters) {
            timeout =
                6000 +
                job_data.DesignParameters.NumFlat * 2000 +
                job_data.DesignParameters.NumGable * 3000 +
                job_data.DesignParameters.NumDeck * 2000;
        }

        if (api_url.includes("/engineering")) {
            timeout = timeout * 1.8;
        }

        if (window.debug) timeout = timeout * 3;

        return new Promise((resolve) => {
            fetchTimeout(
                api_url,
                {
                    signal: window?.loading2d_controller?.signal,
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        user_id: user_id,
                        job_id: job_data.id,
                        request_id: request_id,
                        job: job_ini,
                        wind_data: job_data?.SiteParameters?.WindData,
                        area_index: area_index,
                        session_id: window?.session_id,
                        business_code: job_data?.BusinessCode,
                        brand: window.LYSAGHT ? "Lysaght" : "Fielders",
                        threed: threeDMode && threeDMiniMode ? true : false,
                    }),
                    retry: true,
                    retry_timeout: timeout * 2,
                    request_id: request_id,
                },
                timeout
            )
                .then(async (response) => {
                    if (response === undefined) {
                        dispatch({
                            type: TOGGLE_DESIGNER,
                            parameter: SHOW_LOADING_BAR,
                            value: false,
                        });
                        return resolve(false);
                    }

                    let json = await response.json();

                    if (json.request_id && toNumber(json.request_id) != toNumber(window.loading2d_id)) {
                        return resolve(false);
                    }

                    window.loading2d = false;

                    if (json.Error) {
                        if (json.Locked) {
                            if (job_data) {
                                let new_job = deepCopy(job_data);

                                new_job.App.Locked = true;
                                new_job.App.LockMessage = json.Error;

                                dispatch({
                                    type: NEW_JOB,
                                    parameter: new_job,
                                });
                            }

                            dispatch({
                                type: TOGGLE_DESIGNER,
                                parameter: SHOW_LOADING_BAR,
                                value: false,
                            });
                        } else {
                            throw json.Error;
                        }
                    }
                    if (json.obj_url) {
                        dispatch({
                            type: UPDATE_3D_MODEL,
                            parameter: "area_all",
                            value: json.obj_url,
                        });
                    }

                    if (json.Dimensions) {
                        dispatch(updateQuoteParameters("AREA_DIMENSIONS", json.Dimensions));
                        setTimeout(() => {
                            let new_job = deepCopy(getState().job);
                            new_job.QuoteParameters.AREA_DIMENSIONS = json.Dimensions;
                            new_job = JOBSTATE_VALIDATION.validateFullJob(
                                getState().config,
                                new_job,
                                -1,
                                getState().app
                            );
                            dispatch({
                                type: "NEW_JOB",
                                parameter: new_job,
                            });
                        }, 300);
                    }

                    window.svg_data = null;

                    if (json["svg_data"] || json["svg"]) {
                        window.svg_data = json["svg_data"];

                        var svg_url = json["svg"];
                        window.job = { ...getState().job };
                        if (!json["EngineeringResults"]) {
                            LoadSVGFromData(json["svg_data"], svg_url); // must be kept at the top of the heap for performance

                            setTimeout(() => {
                                dispatch({
                                    type: TOGGLE_DESIGNER,
                                    parameter: SHOW_LOADING_BAR,
                                    value: false,
                                });

                                resolve(true);

                                if (json.Dimensions) {
                                    dispatch(updateQuoteParameters("AREA_DIMENSIONS", json.Dimensions));
                                }
                                dispatch(updateAPP("loadingEngineering", false));
                                return;
                            }, 700);
                            return;
                        } else {
                            if ("EngineeringResults" in json) {
                                let new_engineering = {
                                    ...getState().job.QuoteParameters.ENGINEERING,
                                    ...json,
                                };
                                new_engineering.engineeringHashCode = GetShapeUpdateString(false, true);
                                new_engineering.svg_data = null;
                                new_engineering.EngineeringResults = json["EngineeringResults"];
                                window.job.QuoteParameters.ENGINEERING = new_engineering;

                                LoadSVGFromData(json["svg_data"], svg_url); // must be kept at the top of the heap for performance

                                setTimeout(() => {
                                    const state = getState();
                                    const {
                                        job,
                                        app,
                                        app: { user },
                                        config,
                                    } = state;

                                    dispatch(updateQuoteParameters("ENGINEERING", new_engineering));

                                    if (json.Dimensions) {
                                        dispatch(updateQuoteParameters("AREA_DIMENSIONS", json.Dimensions));
                                        setTimeout(() => {
                                            let new_job = deepCopy(getState().job);
                                            new_job.QuoteParameters.AREA_DIMENSIONS = json.Dimensions;
                                            new_job = JOBSTATE_VALIDATION.validateFullJob(
                                                getState().config,
                                                new_job,
                                                -1,
                                                getState().app
                                            );
                                            dispatch({
                                                type: "NEW_JOB",
                                                parameter: new_job,
                                            });
                                        }, 300);
                                    }

                                    if (job?.QuoteParameters) {
                                        const jobToCheck = { ...job };
                                        jobToCheck.QuoteParameters.ENGINEERING = new_engineering;

                                        const warnings = JOBSTATE_VALIDATION.getWarnings(jobToCheck, user, config);

                                        if (warnings?.message) {
                                            dispatch({
                                                type: SHOW_DESIGNER_MESSAGE,
                                                message: warnings.message,
                                            });
                                        }

                                        let standardErrors = jobStateErrorPopups({ config, job, app, dispatch });

                                        if (standardErrors && standardErrors.error) {
                                            dispatch(showDialogData(standardErrors));
                                        }
                                    }

                                    dispatch({
                                        type: TOGGLE_DESIGNER,
                                        parameter: SHOW_LOADING_BAR,
                                        value: false,
                                    });

                                    dispatch(updateAPP("loadingEngineering", false));

                                    resolve(true);

                                    if ("Data" in json) {
                                        dispatch(updateQuoteParameters("AREA_DATA", json["Data"]));
                                    }
                                }, 700);
                            }
                            return;
                        }

                        // dispatch({
                        //     type: TOGGLE_DESIGNER,
                        //     parameter: SHOW_LOADING_BAR,
                        //     value: false,
                        // });

                        // if (json.Dimensions) {
                        //     dispatch(updateQuoteParameters("AREA_DIMENSIONS", json.Dimensions));
                        // }
                        return;
                    }

                    dispatch(updateAPP("loadingEngineering", false));

                    if (json.svg) {
                        var svg_url = json["svg"];
                        if ("Data" in json) {
                            dispatch(updateQuoteParameters("AREA_DATA", json["Data"]));
                        }
                        if ("EngineeringResults" in json) {
                            let new_engineering = {
                                ...getState().job.QuoteParameters.ENGINEERING,
                                ...json,
                            };
                            window.job = { ...getState().job };
                            new_engineering.engineeringHashCode = GetShapeUpdateString(false, true);

                            new_engineering.EngineeringResults = json["EngineeringResults"];
                            dispatch(updateQuoteParameters("ENGINEERING", new_engineering));

                            setTimeout(() => {
                                const state = getState();
                                const {
                                    job,
                                    app,
                                    app: { user },
                                    config,
                                } = state;

                                if (job?.QuoteParameters) {
                                    const jobToCheck = { ...job };
                                    jobToCheck.QuoteParameters.ENGINEERING = new_engineering;

                                    const warnings = JOBSTATE_VALIDATION.getWarnings(jobToCheck, user, config);

                                    if (warnings?.message) {
                                        dispatch({
                                            type: SHOW_DESIGNER_MESSAGE,
                                            message: warnings.message,
                                        });
                                    }

                                    let standardErrors = jobStateErrorPopups({ config, job, app, dispatch });

                                    if (standardErrors && standardErrors.error) {
                                        dispatch(showDialogData(standardErrors));
                                    }
                                }
                            }, 1000);
                        }

                        if (!json["svg_data"]) {
                            dispatch({
                                type: UPDATE_2D_DESIGNER_SVGS,
                                parameter: "area_all",
                                value: svg_url,
                            });
                        }
                        resolve(true);
                    } else {
                        dispatch({
                            type: TOGGLE_DESIGNER,
                            parameter: SHOW_LOADING_BAR,
                            value: false,
                        });
                        resolve(false);
                    }

                    if (json.Dimensions) {
                        dispatch(updateQuoteParameters("AREA_DIMENSIONS", json.Dimensions));
                    }
                })
                .catch((e) => {
                    if (e?.message?.includes && e.message.includes("aborted")) {
                        return resolve(false);
                    }
                    window.loading2d = false;

                    let message = "Error loading layout from QikQuote server.";
                    if (typeof e === "string") message = e;
                    if (e.message === "failed to fetch")
                        message = "SERVER NOT REACHABLE. Check internet connection, then try again in a few minutes...";
                    dispatch({
                        type: TOGGLE_DESIGNER,
                        parameter: SHOW_LOADING_BAR,
                        value: false,
                    });
                    dispatch({
                        type: SHOW_DESIGNER_MESSAGE,
                        message: "Error: " + message,
                    });
                    return resolve(false);
                });
        });
    };

export const updateLayout3D =
    (force = false, job_data = null) =>
    (dispatch, getState) => {
        checkInternetConnection(dispatch);

        let user_id = getState().app.user.id;
        let online = getState().app.online;
        if (!online) return;

        window.loading2d = false;

        const threeDMode = getState().app.designer[THREED_MODE];
        const threeDMiniMode = getState().app.designer[THREED_MINI_MODE];

        if (threeDMode && threeDMiniMode && !force) return; // this is catered for in combined request in SVG

        if (!job_data) job_data = getState().job;
        if (!job_data) {
            dispatch({
                type: TOGGLE_DESIGNER,
                parameter: SHOW_LOADING_BAR,
                value: false,
            });
            return;
        }
        if (!job_data?.AreaSpecifications?.length) {
            dispatch({
                type: TOGGLE_DESIGNER,
                parameter: SHOW_LOADING_BAR,
                value: false,
            });
            return;
        }

        let job_ini = convertJobStateToIni(job_data, getState().app, "3D", getState().config);
        let id = getState().job.id;
        let api_url = API_BASE() + "obj/" + id;

        setTimeout(() => {
            if (window.loading3d) {
                dispatch({
                    type: TOGGLE_DESIGNER,
                    parameter: SHOW_LOADING_BAR,
                    value: true,
                });
            }
        }, 1500);

        window.loading3d = true;

        if (window.loading3d_controller) {
            window.loading3d_controller.abort();
            if (window.loading3d_id) {
                window.fetchTimeoutCompleted[window.loading3d_id] = true;
            }
        }

        let request_id = Date.now();
        window.loading3d_id = request_id;
        if (window.AbortController) window.loading3d_controller = new AbortController();

        let timeout = 12000;
        if (job_data?.DesignParameters) {
            timeout =
                6000 +
                job_data.DesignParameters.NumFlat * 3000 +
                job_data.DesignParameters.NumGable * 4000 +
                job_data.DesignParameters.NumDeck * 3000;
        }

        return fetchTimeout(
            api_url,
            {
                signal: window?.loading3d_controller?.signal,
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    user_id: user_id,
                    job_id: job_data.id,
                    job: job_ini,
                    request_id: request_id,
                    session_id: window?.session_id,
                    business_code: job_data?.BusinessCode,
                    brand: window.LYSAGHT ? "Lysaght" : "Fielders",
                }),
                retry: true,
                retry_timeout: timeout * 1.3,
                request_id: request_id,
            },
            timeout
        )
            .then(async (response) => {
                if (response === undefined) {
                    dispatch({
                        type: TOGGLE_DESIGNER,
                        parameter: SHOW_LOADING_BAR,
                        value: false,
                    });
                    return;
                }

                let json = await response.json();

                if (json.request_id != window.loading3d_id) return;
                if (response === undefined) return;

                window.loading3d = false;
                if (json.Error) {
                    throw json.Error;
                }
                if (json.obj_url) {
                    dispatch({
                        type: UPDATE_3D_MODEL,
                        parameter: "area_all",
                        value: json.obj_url,
                    });

                    if (json.Locked) {
                        if (job_data) {
                            let new_job = deepCopy(job_data);

                            new_job.App.Locked = true;
                            new_job.App.LockMessage = json.LockMessage;

                            dispatch({
                                type: NEW_JOB,
                                parameter: new_job,
                            });
                        }
                    }
                } else {
                    dispatch({
                        type: TOGGLE_DESIGNER,
                        parameter: SHOW_LOADING_BAR,
                        value: false,
                    });
                }
            })
            .catch((e) => {
                if (e?.message?.includes && e.message.includes("aborted")) {
                    return;
                }

                window.loading3d = false;

                let message = "Error loading model from QikQuote server.";
                if (e?.message) message = e.message;
                if (e.message === "failed to fetch")
                    message = "SERVER NOT REACHABLE. Check internet connection, then try again in a few minutes...";
                dispatch({
                    type: TOGGLE_DESIGNER,
                    parameter: SHOW_LOADING_BAR,
                    value: false,
                });
                dispatch({
                    type: SHOW_DESIGNER_MESSAGE,
                    message: "Error: " + message,
                });
            });
    };

export const uploadBackup = (job_id, filename_prefix, order_data) => {
    if (order_data?.items?.length && order_data?.items?.length > 2) {
        let help_base_url = API_BASE() + "document/" + job_id;

        const currentDate = new Date();
        const day = String(currentDate.getDate()).padStart(2, "0");
        const month = currentDate.toLocaleString("default", { month: "short" });
        const year = String(currentDate.getFullYear()).slice(-2);
        const date_string = `${day}.${month}.${year}`;

        let filename = filename_prefix + date_string + "_" + currentDate.toLocaleTimeString() + ".json";
        fetchTimeout(help_base_url, {
            method: "PUT",
            body: JSON.stringify({
                document_type: "text",
                document_name: filename,
                document_data: order_data,
            }),
        });
    }
};

export const updateDocumentData =
    (job_data, document_type, timeout = 100000) =>
    async (dispatch, getState) => {
        const config = getState()?.config;
        const designTemplate = job_data?.AreaSpecifications[0]?.SHAPE?.DesignTemplateName;
        const num_areas = job_data.AreaSpecifications.length;
        let appendPDF = [];
        timeout += num_areas * 20000;

        console.log(document_type);
        if (document_type == null || document_type == "") return;

        if (document_type === "Production Layouts") {
            appendPDF = Drawings(job_data, config);
        }

        if (designTemplate && document_type === "Job Summary Layouts") {
            const searchCondition = {
                "Area.DesignTemplateName": designTemplate,
            };

            appendPDF = Drawings(job_data, config, null, null, searchCondition);
        }

        if (Array.isArray(document_type)) {
            appendPDF = document_type;
            document_type = "";
        }

        let api_url = API_BASE() + "document/" + job_data.id + "/" + document_type;

        let user_id = getState().app.user.id;
        let job_ini = convertJobStateToIni(job_data, getState().app, "", getState().config);
        dispatch(updateDesigner(GENERATING_DOCUMENT, document_type));
        dispatch(updateDesigner(GENERATING_DOCUMENT_STATUS, "1,Contacting Server"));

        let threedlayout = job_data?.QuoteParameters?.DOCUMENTS?.["3DScreenShots"]?.[0];
        let threed_screenshot = null;
        if (threedlayout) {
            let threed_screenshot_url = API_BASE() + "document/" + job_data.id + "/" + threedlayout;
            let blob = await getImageBlob(threed_screenshot_url);
            let base64 = await blobToBase64(blob);
            threed_screenshot = base64;
        }

        let business_logo = null;
        if (job_data.Distributor.Logo) {
            let business_logo_url =
                API_BASE() + "document/BUS_" + job_data.Distributor.Code + "/" + job_data.Distributor.Logo;
            let blob = await getImageBlob(business_logo_url);
            if (blob) {
                let base64 = await blobToBase64(blob);
                business_logo = base64;
            }
        }

        let job_raw = {};
        let material_list = job_data?.QuoteParameters?.BOM?.OrderList;
        if (!material_list || !material_list?.items) material_list = job_data?.QuoteParameters?.BOM?.SystemList;

        let bracketData = [];
        if (document_type === "TEST BRACKETS" || document_type === "Production Layouts") {
            bracketData = GetBracketDataForOpal(material_list, job_data);
        }

        if (document_type === "Quote Layout") {
            job_raw = {
                ...job_data,
                QuoteParameters: {
                    ...job_data.QuoteParameters,
                    BOM: null,
                },
            };
        }

        let request_id = Date.now() + "_" + GetRandomInt(1000, 9999);

        const checkDocumentStatus = () => {
            let generatingState = getState().app?.designer?.GENERATING_DOCUMENT;

            if (generatingState) {
                fetchTimeout(
                    API_BASE() + "document/" + job_data.id + "/" + request_id + ".status",
                    {
                        method: "GET",
                    },
                    2000
                ).then(async (response) => {
                    if (response.status && response.status >= 200 && response.status <= 300 && response?.text) {
                        let response_text = await response.text();
                        dispatch(updateDesigner(GENERATING_DOCUMENT_STATUS, response_text));
                        setTimeout(function () {
                            checkDocumentStatus();
                        }, 1000);
                    } else {
                        setTimeout(function () {
                            checkDocumentStatus();
                        }, 1000);
                    }
                });
            }
        };
        setTimeout(function () {
            checkDocumentStatus();
        }, 1000);

        return fetchTimeout(
            api_url,
            {
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    document_type: document_type,
                    user_id: user_id,
                    job_id: job_data.id,
                    job: job_ini,
                    order_list: material_list,
                    wind_data: job_data?.SiteParameters?.WindData,
                    brand: window.LYSAGHT ? "Lysaght" : "Fielders",
                    job_raw:
                        document_type === "Quote Layout" ||
                        document_type === "Council Report" ||
                        document_type === "Production Layouts" ||
                        document_type === "Engineering Documentation" ||
                        document_type === "Footing Layouts"
                            ? job_data
                            : null,
                    threed_screenshot: threed_screenshot,
                    business_logo: business_logo,
                    request_id: request_id,
                    appendPDF: appendPDF,
                    bracketData: bracketData,
                    numAreas: num_areas,
                }),
            },
            timeout
        )
            .then(async (response) => {
                if (response?.status && response.status >= 200 && response.status <= 300) {
                    let json = await response.json();

                    if (json.Error) {
                        throw json;
                    } else if (json.document_filename) {
                        dispatch(updateDocument(document_type, json.document_filename));
                        dispatch(updateDesigner(DOCUMENT_TO_SHOW, json.document_filename));
                        dispatch(updateDesigner(GENERATING_DOCUMENT, false));
                    } else {
                    }

                    if (document_type === "Quote Layout") {
                        uploadBackup(job_data.id, "Component_List_Backup_(Quote_Layout_Generated)", material_list);
                    }

                    dispatch(updateDesigner(GENERATING_DOCUMENT_STATUS, false));
                } else {
                    dispatch(updateDesigner(GENERATING_DOCUMENT, false));
                    dispatch(updateDesigner(GENERATING_DOCUMENT_STATUS, false));
                    throw {
                        message: "Could not generate layout at this time. Please wait a moment and try again.",
                    };
                }
            })
            .catch((e) => {
                let message = "Could not generate layout at this time. Please wait a moment and try again.";
                if (e?.message) message = e.message;
                if (e?.message === "failed to fetch") message = "Error loading ... QikQuote server is not accesible.";
                dispatch({
                    type: SHOW_DESIGNER_MESSAGE,
                    message: "Error: " + message,
                });
                dispatch(updateDesigner(GENERATING_DOCUMENT, false));
                dispatch(updateDesigner(GENERATING_DOCUMENT_STATUS, false));
            });
    };

export const DStateActive = ({ config }) => {
    return false; // always set to false for now...
    let DStateActive = config.region?.D365_State_Active || window.location.href.toLowerCase().includes("sit.");
    if (DStateActive !== true) {
        DStateActive = false;
    }
    return DStateActive;
};
